import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AuthenticationService } from './share-modul/services/authentication/authentication.service';
import { TranslationHelperService } from './share-modul/services/translation-helper/translation-helper.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService]
})

export class AppComponent implements OnInit {

  public unsubscribe: Subject<void> = new Subject<void>();
  public isLoggedin: boolean = false;

  public isManager: boolean = false;
  public isAdmin: boolean = false;

  public routerEventsSubscription: Subscription;
  public isWaiterRoute: boolean = false;
  public isWaitersGeneralRoute: boolean = false;

  constructor(
    public _router: Router,
    private translationHelperService: TranslationHelperService,
    public authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.initTranslate();
    this.authenticationService.loginUser.pipe(takeUntil(this.unsubscribe)).subscribe(response => {
      this.isLoggedin = !!response;
    })
    this.authenticationService.isLoggedIn$.subscribe((result) => {
      this.isLoggedin = result
    });

    this.routerEventsSubscription = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkRouterState();
      }
    });

    this.authenticationService.isManager$.subscribe((result) => {
      this.isManager = result;
    });
    this.authenticationService._isAdmin$.subscribe((result) => {
      this.isAdmin = result;
    });
  
  }

  public checkRouterState(){
    const currentRoute = this._router.routerState.snapshot.root;
    this.isWaiterRoute = this.getWaiterRouteData(currentRoute); 
    this.isWaitersGeneralRoute = this.getWaitersGeneralRouteData(currentRoute); 
  }

  public getWaiterRouteData(route: any): boolean {
    if (route.data && route.data.isWaiterRoute !== undefined) {
      return route.data.isWaiterRoute;
    }

    if (route.firstChild) {
      return this.getWaiterRouteData(route.firstChild);
    }

    return false;
  }
  
  public getWaitersGeneralRouteData(route: any): boolean {
    if (route.data && route.data.isWaitersGeneralRoute !== undefined) {
      return route.data.isWaitersGeneralRoute;
    }

    if (route.firstChild) {
      return this.getWaitersGeneralRouteData(route.firstChild);
    }

    return false;
  }

  private initTranslate(): void {
    this.translationHelperService.initializeTranslate();
  }
}
